<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入您的姓名"></el-input>
      </el-form-item>
      <el-form-item label="机构" prop="org">
        <el-input v-model="ruleForm.org" placeholder="请输入您的机构名称"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="tel">
        <el-input v-model="ruleForm.tel" placeholder="请输入您的电话"></el-input>
      </el-form-item>
      <el-form-item label="留言" prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc" placeholder="请输入您要洽谈的内容"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" class="submit-btn">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "negotiation",
  data() {
    return {
      ruleForm: {
        name: '',
        org: '',
        tel: '',
        desc: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'}
        ],
        org: [
          {required: true, message: '请输入您的机构名称', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入您的电话', trigger: 'blur'}
        ],
        desc: [
          {required: true, message: '请输入您要洽谈的内容', trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.apiContent.submitMessage({
            name:this.ruleForm.name,
            user_id:this.$route.query.id,
            tel:this.ruleForm.tel,
            org_name:this.ruleForm.org,
            content:this.ruleForm.desc
          }).then(()=>{
            this.$message.success('提交成功 ')
            this.$emit('submitOk')
            this.ruleForm= {
              name: '',
              org: '',
              tel: '',
              desc: '',
            }
          }).catch(e=>{
            this.$message.success(e.msg)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },



  }
}
</script>

<style scoped lang="scss">
.submit-btn {
  display: block;
  margin: 0 auto;
  width: 140px;
  height: 40px;
  padding: 0;
  line-height: 40px;
  position: relative;
  left: -50px;
  background: #c70005!important;
  border: 1px solid #c70005!important;
}
</style>
